import './AddandEditCustomer.css';

import React, { useEffect, useMemo, useState } from 'react';

import { CMSCustomer } from '../../../types/CMSTypes';
import { selectUser } from '../../../redux/reducers/userReducer';
import { useSelector } from 'react-redux';

interface AddandEditCustomerProps {
  onClose: () => void;
  onSave: (customerData: Partial<CMSCustomer>) => void;
  onDeactivate: (customerId: string) => void;
  customer: CMSCustomer | null;
}

const PLANS = [
  { title: 'Basic', value: 'basic' },
  { title: 'Standard', value: 'standard' },
  { title: 'Pro', value: 'pro' },
];

const AddandEditCustomer: React.FC<AddandEditCustomerProps> = ({
  onClose,
  onSave,
  onDeactivate,
  customer,
}) => {
  const user = useSelector(selectUser);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const isEditFlow = useMemo(
    () => !!customer?.id || !!customer?.customerId,
    []
  );
  const isAdmin = useMemo(() => user?.data?.user?.userType === 'admin', []);

  const [formData, setFormData] = useState({
    id: customer?.id || customer?.customerId || undefined,
    name: customer?.name || '',
    email: customer?.email || '',
    password: customer?.password || '',
    subscriptionType: customer?.subscriptionType || PLANS[0].value,
    institutionName: customer?.institutionName || '',
    domain: customer?.domain || '',
    numberOfUsers: customer?.numberOfUsers || '',
    endDate: customer?.endDate?._seconds
      ? new Date(customer?.endDate?._seconds).toDateString()
      : '',
    vatNumber: customer?.vatNumber || '',
    country: customer?.country || '',
    price: customer?.price || '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  const handleDeactivate = () => {
    onDeactivate(customer?.customerId || customer?.id || '');
  };

  return (
    <div className='modal-overlay-add'>
      <div className='modal-container-add'>
        <div className='modal-header-add'>
          <div className='modal-title-add'>
            {isEditFlow ? 'Edit Customer' : 'Add Customer'}
          </div>
          <button className='close-button' onClick={onClose}>
            X
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className='modal-body-add'>
            <div className='input-row-add'>
              <span className='input-group-add'>
                <label>User Name</label>
                <input
                  type='text'
                  name='name'
                  placeholder='Name'
                  value={formData.name}
                  onChange={handleChange}
                />
              </span>
              <span className='input-group-add'>
                <label>General Contact (Email)</label>
                <input
                  type='email'
                  name='email'
                  placeholder='Email'
                  value={formData.email}
                  onChange={handleChange}
                />
              </span>
            </div>

            <div className='input-row-add'>
              <span className='input-group-add'>
                <label>Subscription Type</label>
                <select
                  type='text'
                  name='subscriptionType'
                  placeholder='Subscription Type'
                  value={formData.subscriptionType}
                  onChange={handleChange}
                >
                  {PLANS.map((item) => {
                    return <option value={item.value}>{item.title}</option>;
                  })}
                </select>
              </span>
              <span className='input-group-add'>
                <label>Institution Name</label>
                <input
                  type='text'
                  name='institutionName'
                  placeholder='Institution Name'
                  value={formData.institutionName}
                  onChange={handleChange}
                />
              </span>
            </div>

            <div className='input-row-add'>
              <span className='input-group-add'>
                <label>Domain</label>
                <input
                  type='text'
                  name='domain'
                  placeholder='Domain'
                  value={formData.domain}
                  onChange={handleChange}
                />
              </span>
              <span className='input-group-add'>
                <label>No of Users</label>
                <input
                  type='number'
                  name='numberOfUsers'
                  placeholder='No of Users'
                  value={formData.numberOfUsers}
                  onChange={handleChange}
                />
              </span>
            </div>
            <div className='input-row-add'>
              <span className='input-group-add'>
                <label>End Date(Valid Until)</label>
                <input
                  type='date'
                  name='endDate'
                  placeholder='End Date(Valid Until)'
                  value={formData.endDate}
                  onChange={handleChange}
                />
              </span>
              <span className='input-group-add'>
                <label>Country</label>
                <input
                  type='text'
                  name='country'
                  placeholder='Country'
                  value={formData.country}
                  onChange={handleChange}
                />
              </span>
            </div>
            <div className='input-row-add'>
              <span className='input-group-add'>
                <label>Password</label>
                <input
                  type='text'
                  name='password'
                  placeholder='Password'
                  value={formData.password}
                  onChange={handleChange}
                />
              </span>
              <span className='input-group-add'>
                <label>Vat Number</label>
                <input
                  type='text'
                  name='vatNumber'
                  placeholder='Vat Number'
                  value={formData.vatNumber}
                  onChange={handleChange}
                />
              </span>
            </div>
            <div className='input-row-add'>
              <span className='input-group-add'>
                <label>Price</label>
                <input
                  type='number'
                  name='price'
                  placeholder='Price'
                  value={formData.price}
                  onChange={handleChange}
                />
              </span>
            </div>

            <div className='modal-footer-add'>
              {isEditFlow && (
                <button
                  type='button'
                  className='deactivate-button-add'
                  onClick={handleDeactivate}
                >
                  Deactivate
                </button>
              )}
              <button
                type='button'
                className='cancel-button-add'
                onClick={onClose}
              >
                Cancel
              </button>
              <button type='submit' className='save-button-add'>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddandEditCustomer;
